import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Globe } from 'lucide-react';

export default function Header() {
  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex items-center">
              <img 
                src="/tools/proxyscrape_logo.svg" 
                alt="ProxyScrape" 
                className="h-8 w-auto"
              />
            </Link>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <Link 
                to="/" 
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-900"
              >
                <Wrench className="h-4 w-4 mr-2" />
                Tools
              </Link>
              <a 
                href="https://proxyscrape.com/" 
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-900"
              >
                <Globe className="h-4 w-4 mr-2" />
                Proxies
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
